module.exports = __webpack_public_path__ + "assets/icons/ic_signal_tower.svg";